import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m5.638 6.925-4.1 4.1a.82.82 0 0 1-.625.262A.9.9 0 0 1 .288 11a.875.875 0 0 1 0-1.275L4.363 5.65l-4.1-4.1A.83.83 0 0 1 0 .912.92.92 0 0 1 .288.275a.875.875 0 0 1 1.275 0l4.075 4.1 4.1-4.1a.875.875 0 0 1 1.275 0 .874.874 0 0 1 0 1.275l-4.1 4.1 4.1 4.1a.86.86 0 0 1 .275.625.86.86 0 0 1-.275.625.875.875 0 0 1-1.275 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }